import { render, staticRenderFns } from "./CostReportDetail.vue?vue&type=template&id=5053ca25"
import script from "./CostReportDetail.vue?vue&type=script&lang=js"
export * from "./CostReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports